import OrderDetailInformation from "../Order/OrderDetailInformation";
import React, { Fragment, useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../CustomedFields/FormikControl";
import roMeasurementSave from "../../Models/roMeasurementSave";
import roOrderDetailSave from "../../Models/roOrderDetailSave";
import _measurementService from "./../../services/measurementServices";
import _orderDetailService from "./../../services/orderDetailServices";

// React Notification
import { NotificationManager } from "react-notifications";

//** get actions from store */
import { useSelector, useDispatch } from "react-redux";
import {
  clearOrderItemDetailStore,
  addOrderItemDetailStore,
  removeOrderItemDetailStore,
  addOrderItemWithMeasurementsStore,
  removeOrderItemWithMeasurementsStore,
  addOrderItemUniqueStore,
  removeOrderItemUniqueStore,
  updateViewModeOrderItemDetailStore,
  updateOrderDetailGUID_OrderItemDetailStore,
} from "./../../slice/orderSlice";
import { useTabIndex } from "react-tabindex";

const AddEditSingleMeasurementOnOrderPage = (props) => {
  const tabIndex = useTabIndex();
  const [countRow, setCountRow] = useState(0);
  const [countCol, setCountCol] = useState(0);
  const tabIndexArray = [];
  var rowCounter = 0;
  var colCounter = 0;

  //Note Checked
  const [noteChecked, setNoteChecked] = useState([]);
  const noteChecked_array = new Array();

  const add_CheckboxChange_Item = (itemName) => {
    // alert("add: " + itemName);
    setNoteChecked([...noteChecked, itemName]);

    // // Remove the unchecked note ID from the array
    // setNoteChecked((prev) => prev.filter((note) => note !== value));

    //noteChecked_array.push(itemName);

    //alert(noteChecked);
    console.log(
      "add_CheckboxChange_Item :: itemName ----> " + JSON.stringify(itemName)
    );
    console.log("add_CheckboxChange_Item ----> " + JSON.stringify(noteChecked));
  };

  const remove_CheckboxChange_Item = (itemName) => {
    // alert("remove : " + itemName);
    setNoteChecked(noteChecked.filter((note) => note !== itemName));

    // alert(JSON.stringify(noteChecked));
    console.log(
      "remove_CheckboxChange_Item ----> " + JSON.stringify(noteChecked)
    );
  };

  // Function to increment count by 1
  // const incrementRowCount = () => {
  //   setCountRow(countRow + 1);
  //   console.log("countRow ====>>" + countRow);
  // };
  // const incrementColCount = () => {
  //   setCountCol(countCol + 1);
  //   console.log("countCol ====>>" + countCol);
  // };
  // const resetColCount = () => {
  //   setCountCol(0);
  //   console.log("countCol ====>>" + countCol);
  // };

  var tabIndexRowNoCurrent = 0;
  var tabIndexColumnNoCurrent = 0;
  //*** Store */
  const dispatch = useDispatch();
  //Get state from store
  const {
    customerStore,
    customerInfoModeStore,
    customerGUIDStore,
    orderStore,
    orderInfoModeStore,
    orderGUIDStore,
    orderItemDetailStore,
    orderItemsWithMeasurementStore,
    orderItemsUniqueStore,
    isLoadingStore,
  } = useSelector((state) => state.order);

  // alert(
  //   "props.lstMeasurementDetail[0]?.productItemID_GUID: " +
  //     props.lstMeasurementDetail[0]?.productItemID_GUID
  // );
  // alert("props.settingsID: " + props.settingsID);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [
    disabledAfterSuccessfullSubmitting,
    setDisabledAfterSuccessfullSubmitting,
  ] = useState(false);
  const [orderDetailGUID_state, setOrderDetailGUID_state] = useState("");

  const [initialNew, setInitialNew] = useState({
    indexEntry: props.indexEntry,
    productItemID_GUID: props.lstMeasurementDetail[0]?.productItemID_GUID,
    settingsID: props.settingsID,
    orderItemUnitPrice: props.makingCharge,
    orderItemQty: 1,
  });

  //*** dynamic Form initial value assign */
  //Knowledge-404
  // SOURCE LINK: https://stackoverflow.com/questions/55661783/how-can-i-edit-an-input-added-dynamically-without-my-input-data-populating-othe
  //   initialValues={Object.assign(initialFields, ...extraFields)}
  // Example:::
  // const extraFieldsForInitialValues = x.map((num) => ({
  //   [`name${num}`]: "",
  //   [`description${num}`]: "",
  // }));

  var initialValues = {
    indexEntry: props.indexEntry,
    productItemID_GUID: props.lstMeasurementDetail[0]?.productItemID_GUID,
    settingsID: props.settingsID,
    orderItemUnitPrice:
      props.orderProductItem[0]?.unitPrice === "undefined"
        ? props.makingCharge
        : props.orderProductItem[0]?.unitPrice, // props.makingCharge,
    orderItemQty:
      props.orderProductItem[0]?.qty === "undefined"
        ? 1
        : props.orderProductItem[0]?.qty, // 1,
    note:
      props.orderProductItem[0]?.note === "undefined"
        ? ""
        : props.orderProductItem[0]?.note,
    orderDetailID_GUID:
      props.orderDetailID_GUID_props === "undefined"
        ? ""
        : props.orderDetailID_GUID_props,
  };

  // const extraFieldsForInitialValues = [];
  console.log(
    "props.lstMeasurementDetail : ----------------------------><>> " +
      JSON.stringify(props.lstMeasurementDetail)
  );

  console.log("orderDetailID_GUID : " + props.orderDetailID_GUID_props);

  // ** accordian
  // const collepseFn = (element) => {
  //   alert("The accordian was clicked.: " + element);
  //   // document.getElementById("demo");
  //   // var panel = document.getElementById(id);
  //   var panel = element.nextElementSibling;
  //   if (panel.style.display === "block") {
  //     panel.style.display = "none";
  //   } else {
  //     panel.style.display = "block";
  //   }
  // };

  const handleClick = (event) => {
    var element = event.target;
    // alert("The accordian was clicked.: " + element);
    var panel = element.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  };

  useEffect(() => {
    debugger;

    //NOTE : note check box set initial array values

    props.lstMeasurementDetail
      .filter((measurementDetail) => {
        return measurementDetail.isNote === true;
      })
      .map((item, index) => {
        // alert(
        //   "SET initial checkbox ===> item.value ----------->>>> " + item.value
        // );
        if (
          item.fieldType === 2 &&
          item.value !== "" &&
          item.value === "True"
        ) {
          // alert(item.value);
          //DUCKtap: below code
          let arrayNote = noteChecked;
          arrayNote.push(item.measurementSettingsDetailsID_GUID);
          setNoteChecked(arrayNote);
          console.log("arrayNote------>> " + arrayNote);
          // alert("noteChecked" + noteChecked);
        }
      });

    // alert(
    //   "INITIAL : JSON.stringify(noteChecked)" + JSON.stringify(noteChecked)
    // );
    // alert(JSON.stringify(props.lstMeasurementDetail));

    // ** accordian
    // var acc = document.getElementsByClassName("accordion");
    // var i;

    // for (i = 0; i < acc.length; i++) {
    //   acc[i].addEventListener("click", function () {
    //     this.classList.toggle("active");
    //     var panel = this.nextElementSibling;
    //     if (panel.style.display === "block") {
    //       panel.style.display = "none";
    //     } else {
    //       panel.style.display = "block";
    //     }
    //   });
    // }

    //** Old - working fine code */
    // const extraFieldsForInitialValues = props.lstMeasurementDetail.map(
    //   (item, index) => ({
    //     [`${item.measurementSettingsDetailsID_GUID}`]: "",
    //   })
    // );

    const extraFieldsForInitialValues = props.lstMeasurementDetail.map(
      (item, index) => ({
        [`${item.measurementSettingsDetailsID_GUID}`]: item.value,
      })
    );

    const initialValues3 = Object.assign(
      initialValues,
      ...extraFieldsForInitialValues
    );

    // setInitialNew(...Object.values(initialValues3));
    setInitialNew(initialValues3);

    console.log(
      "extraFieldsForInitialValues :: " +
        JSON.stringify(extraFieldsForInitialValues)
    );
    console.log("initialValues :: " + JSON.stringify(initialValues));
    console.log("initialValues3 :: " + JSON.stringify(initialValues3));
    console.log("initialNew :: " + JSON.stringify(initialNew));
  }, []);

  const handleClickModeChange = (indexNo, mode) => {
    // alert("The link was clicked." + indexNo + ", " + mode);
    props.changeMode(indexNo, mode);
  };

  const handleClickDelete = (indexNo, orderDetailID_GUID_props) => {
    // alert(
    //   "The link was clicked." +
    //     indexNo +
    //     ", " +
    //     orderDetailGUID_state +
    //     ", " +
    //     orderDetailID_GUID_props +
    //     ", " +
    //     props.orderDetailID_GUID_props
    // );
    props.removeOrderItem(indexNo, orderDetailGUID_state);
  };

  //******** add measurement to DB     */

  const validationSchema = Yup.object({
    //  MeasurementComments: Yup.string().required("Required"),
    // CellNo: Yup.string().required("Required"),
    // Email: Yup.string().email("Invalid email format"),
  });

  const onSubmit = async (values) => {
    setIsSubmitting(true);
    // debugger;
    // console.log("props.lstMeasurementDetail" + props.lstMeasurementDetail[0]);
    console.log(
      "Submitted -- Form data --------------->>> " + JSON.stringify(values)
    );
    console.log(
      "Submitted -- Form data (Check boxes) --------------->>> " +
        JSON.stringify(noteChecked)
    );

    // alert(
    //   "form submit" +
    //     customerStore?.customerID_GUID +
    //     ", " +
    //     orderStore?.orderID_GUID
    // );
    // props.AddCustomerToDB(values);
    // debugger;

    try {
      if (customerStore === null) {
        NotificationManager.warning(
          "Please save customer information",
          "Warning",
          4000
        );
        return;
      } else if (orderStore === null) {
        NotificationManager.warning(
          "Please save order information",
          "Warning",
          4000
        );
        return;
      }

      debugger;

      let roOrderDetailToSave = new roOrderDetailSave();
      roOrderDetailToSave.CustomerID_GUID = customerStore.customerID_GUID; // props.customerGUID;
      roOrderDetailToSave.ProductItemID_GUID = values.productItemID_GUID; // props.selectedProductItemGUID; //
      roOrderDetailToSave.OrderDetailID_GUID = values.orderDetailID_GUID;
      roOrderDetailToSave.OrderID_GUID = orderStore.orderID_GUID;
      roOrderDetailToSave.MeasurementSettingsID_GUID = props.settingsID;
      roOrderDetailToSave.innerObj = values;
      roOrderDetailToSave.innerObj_checkBox = noteChecked;

      // noteChecked.map(
      //   (item) =>
      //     (roOrderDetailToSave.innerObj = Object.assign(
      //       roOrderDetailToSave.innerObj,
      //       ...{ item: true }
      //     ))
      // );

      // const initialValues3 = Object.assign(
      //   roOrderDetailToSave.innerObj,
      //   ...{"extraFieldsForInitialValues":true}
      // );

      console.log(
        "Submit to save ------------->> roOrderDetailToSave :" +
          JSON.stringify(roOrderDetailToSave)
      );
      // alert("roOrderDetailToSave: " + JSON.stringify(roOrderDetailToSave));

      let result = await _orderDetailService.saveOrderDetailAndMeasurement(
        roOrderDetailToSave
      );

      console.log("result form api: " + JSON.stringify(result));

      //Update
      if (result != null && result?.responseObj != null) {
        //(1)
        setOrderDetailGUID_state(result?.responseObj.orderDetailID_GUID);
        //(2)
        dispatch(
          updateOrderDetailGUID_OrderItemDetailStore({
            indexNo: props.indexEntry,
            orderDetailID_GUID: result?.responseObj.orderDetailID_GUID,
          })
        );

        //Notification
        NotificationManager.success(result?.Message, "Successful!", 4000);
        setDisabledAfterSuccessfullSubmitting(true);
        console.log("result : " + JSON.stringify(result));
      }
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Fragment>
      Mode: {props.entryEditOrViewMode}
      <hr />
      <div className="media mb-4 mt-1 divWithBgColor_edit ">
        <div className="media-body">
          <div className="ordermeasure-title">
            <span className="float-right">
              {/* {props.lstMeasurementDetail.length} */}{" "}
              <div className="btn-group m-b-20">
                {/* {props.mode === 3 && ( */}
                {props.entryEditOrViewMode === 3 && (
                  <button
                    onClick={() => {
                      handleClickModeChange(props.indexEntry, 2);
                    }}
                    type="button"
                    className="btn btn-light"
                  >
                    <i className="fa fa-edit"></i>
                  </button>
                )}
                {props.entryEditOrViewMode === 2 && (
                  <button
                    onClick={() => {
                      handleClickModeChange(props.indexEntry, 3);
                    }}
                    type="button"
                    className="btn btn-light"
                  >
                    <i className="fa fa-crosshairs" aria-hidden="true"></i>
                  </button>
                )}
                {/* {(props.mode === 1 || props.mode === 2) && ( */}
                {(props.entryEditOrViewMode === 1 ||
                  props.entryEditOrViewMode === 2) && (
                  <button
                    onClick={() => {
                      handleClickModeChange(props.indexEntry, 3);
                    }}
                    type="button"
                    className="btn btn-light"
                  >
                    <i className="fa fa-save"></i>
                  </button>
                )}

                <button
                  onClick={() => {
                    handleClickDelete(
                      props.indexEntry,
                      props.orderDetailID_GUID_props
                    );
                  }}
                  type="button"
                  className="btn btn-light"
                >
                  <i className="fa fa-trash"></i>
                </button>
              </div>
            </span>
            <h4 className="m-0 text-primary">
              {props.lstMeasurementDetail[0].name}{" "}
              {props.lstMeasurementDetail[0].productItemID_GUID}
              {/* {props.lstMeasurementDetail[0].productItemID_GUID}{" "}
              {props.settingsID} */}
              (
              {
                // props.mode
                (() => {
                  switch (true) {
                    case props.entryEditOrViewMode === 1:
                      {
                        return <>ADD</>;
                      }
                      break;

                    case props.entryEditOrViewMode === 2:
                      {
                        return <>EDIT</>;
                      }
                      break;

                    default:
                      {
                        return <>VIEW</>;
                      }
                      break;
                  }
                })()
              }
              )
            </h4>
          </div>
          <div className="clearBoth"></div>
          <div className="row">
            <div className="col-xl-12">
              <div className="card bg_color_skyBlue">
                <div className="card-body card-body-padding-less">
                  <div className="basic-list-group">
                    <Formik
                      enableReinitialize={true}
                      initialValues={initialNew} // {initialValues} // {initialValues} // {initialNew}
                      validationSchema={validationSchema}
                      onSubmit={onSubmit}
                    >
                      {(formik) => {
                        return (
                          <Form>
                            <div style={{ width: "5px", float: "left" }}>
                              <FormikControl
                                control="input"
                                type="hidden"
                                //label={"Settings GUID"}
                                name={"indexEntry"}
                                // value={
                                //   props.lstMeasurementDetail[0]
                                //     ?.productItemID_GUID
                                // }
                                style={{ width: "5px" }}
                              />
                            </div>
                            <div style={{ width: "5px", float: "left" }}>
                              <FormikControl
                                control="input"
                                type="hidden"
                                //label={"Settings GUID"}
                                name={"settingsID"}
                                // value={
                                //   props.lstMeasurementDetail[0]
                                //     ?.productItemID_GUID
                                // }
                                style={{ width: "50px" }}
                              />
                            </div>
                            <div style={{ width: "5px", float: "left" }}>
                              <FormikControl
                                control="input"
                                type="hidden"
                                // label={"Product Item GUID"}
                                name={"productItemID_GUID"}
                                // value={
                                //   props.lstMeasurementDetail[0]
                                //     ?.productItemID_GUID
                                // }
                                style={{ width: "5px" }}
                              />
                            </div>
                            {/* Comment : Note */}
                            <div
                              style={{
                                width: "150px",
                                float: "right",
                                marginRight: "40px",
                              }}
                            >
                              <FormikControl
                                control="input"
                                type="hidden"
                                // label={"orderDetailID_GUID"}
                                label={""}
                                name={"orderDetailID_GUID"}
                                style={{ width: "130px" }}
                              />
                            </div>
                            {/* Comment : Note */}
                            <div
                              style={{
                                width: "57%",
                                float: "left",
                                marginRight: "20px",
                              }}
                            >
                              <FormikControl
                                control="input"
                                type="text"
                                label={"Note"}
                                name={"note"}
                                style={{ width: "100%" }}
                              />
                            </div>
                            <div
                              style={{
                                width: "150px",
                                float: "left",
                                marginRight: "0px",
                              }}
                            >
                              <FormikControl
                                control="input"
                                type="text"
                                label={"Unit Price"}
                                name={"orderItemUnitPrice"}
                                style={{ width: "130px" }}
                              />
                            </div>
                            <div
                              style={{
                                marginLeft: "10px",
                                width: "150px",
                                float: "left",
                              }}
                            >
                              <FormikControl
                                control="input"
                                type="text"
                                label={"Item Qty"}
                                name={"orderItemQty"}
                                style={{ width: "130px" }}
                              />
                            </div>
                            <div style={{ clear: "both" }}></div>
                            {props.lstMeasurementDetail
                              .filter((measurementDetail) => {
                                return measurementDetail.isNote === false;
                              })
                              .forEach((item, index) => {
                                tabIndexArray.push(
                                  props.blockOrder +
                                    colCounter * 7 +
                                    rowCounter +
                                    1
                                );

                                if ((index + 1) % 7 === 0) {
                                  rowCounter = rowCounter + 1;
                                  colCounter = 0;
                                } else {
                                  colCounter = colCounter + 1;
                                }
                                // tabIndexArray.push(colCounter * 7 + rowCounter);
                              })}
                            {/* {tabIndexArray} */}
                            {props.lstMeasurementDetail
                              .filter((measurementDetail) => {
                                return measurementDetail.isNote === false;
                              })
                              .map((item, index) => {
                                //Row
                                // resetColCount();

                                if ((index + 1) % 7 == 0) {
                                  return (
                                    <>
                                      <FormikControl
                                        key={index}
                                        control="input_libas"
                                        type="text"
                                        // label={tabIndexArray[index]}
                                        label={item.fieldName}
                                        name={
                                          item.measurementSettingsDetailsID_GUID
                                        }
                                        tabIndex={
                                          props.blockOrder + item.orderOfShow
                                        }
                                        // NOTE: comment below; previous tab-Index
                                        // tabIndex={tabIndexArray[index]}
                                        // value={item.orderOfShow}
                                      />
                                      <div className="clearBoth"></div>,
                                    </>
                                  );
                                }

                                // incrementColCount();

                                return (
                                  <FormikControl
                                    key={index}
                                    control="input_libas"
                                    type="text"
                                    // label={tabIndexArray[index]}
                                    label={item.fieldName}
                                    name={
                                      item.measurementSettingsDetailsID_GUID
                                    }
                                    tabIndex={
                                      props.blockOrder + item.orderOfShow
                                    }
                                    // tabIndex={props.blockOrder}
                                    // NOTE: comment below; previous tab-Index
                                    // tabIndex={tabIndexArray[index]}
                                    // value={item.value}
                                  />
                                );
                              })}
                            <div style={{ clear: "both" }}></div>
                            {/* <button className="accordion">Section 1</button>
                            <div className="panel">
                              <p>
                                Lorem ipsum dolor sit amet, consectetur
                                adipisicing elit, sed do eiusmod tempor
                                incididunt ut labore et dolore magna aliqua. Ut
                                enim ad minim veniam, quis nostrud exercitation
                                ullamco laboris nisi ut aliquip ex ea commodo
                                consequat.
                              </p>
                            </div> */}
                            <div
                              className="accordion"
                              style={{
                                marginTop: "3px",
                                fontWeight: "bold",
                              }}
                              onClick={handleClick}
                              // onClick={() => {
                              //   collepseFn(this);
                              // }}
                            >
                              Extended Note ..:
                            </div>
                            <div
                              className="accordionBody"
                              style={{ display: "none" }}
                            >
                              {props.lstMeasurementDetail
                                .filter((measurementDetail) => {
                                  return measurementDetail.isNote === true;
                                })
                                .map((item, index) => {
                                  if (item.fieldType === 1) {
                                    // text box
                                    return (
                                      <>
                                        {/** -- <div style={{ clear: "both" }}></div> */}
                                        <FormikControl
                                          control="Input_libas_extendNote"
                                          type="text"
                                          label={item.fieldName}
                                          name={
                                            item.measurementSettingsDetailsID_GUID
                                          }
                                          // value={item.value}
                                        />
                                      </>
                                    );
                                  } else if (item.fieldType === 2) {
                                    // Check box
                                    return (
                                      <>
                                        {/* <div style={{ clear: "both" }}></div> */}
                                        {/* {JSON.stringify(item)} */}
                                        <FormikControl
                                          control="CheckBox_MeasurementSetting"
                                          type="CheckBox_MeasurementSetting"
                                          label={item.fieldName}
                                          name={
                                            item.measurementSettingsDetailsID_GUID
                                          }
                                          add_CheckboxChange_Item={
                                            add_CheckboxChange_Item
                                          }
                                          remove_CheckboxChange_Item={
                                            remove_CheckboxChange_Item
                                          }
                                          value={item.value}
                                        />
                                      </>
                                    );
                                  }
                                })}
                            </div>
                            <div style={{ clear: "both" }}></div>
                            <hr />
                            <div style={{ clear: "both" }}></div>
                            <div
                              style={{
                                clear: "both",
                                marginBottom: "5px",
                              }}
                            >
                              &nbsp;
                            </div>

                            <div
                              className="accordion"
                              style={{
                                marginTop: "3px",
                                fontWeight: "bold",
                              }}
                              // onClick={handleClick}
                            >
                              Accessories
                            </div>

                            <div>
                              <table
                                className="table table-bordered tableBorder"
                                style={{ border: "1px solid #000" }}
                              >
                                <thead>
                                  <tr style={{ border: "2px solid #000" }}>
                                    <th style={{ textAlign: "center" }}>
                                      SI No.
                                    </th>
                                    <th>Item Name</th>
                                    <th style={{ textAlign: "center" }}>
                                      Quantity
                                    </th>
                                    <th style={{ textAlign: "right" }}>
                                      Unit Price (tk)
                                    </th>
                                    <th style={{ textAlign: "right" }}>
                                      SubTotal (tk)
                                    </th>
                                  </tr>
                                </thead>
                                <tbody></tbody>
                              </table>
                            </div>

                            <button
                              disabled={isSubmitting || !formik.isValid}
                              className="btn btn-primary px-3"
                              id="submitButton"
                              type="submit"
                              // disabled={!formik.isValid}
                              style={{
                                display: disabledAfterSuccessfullSubmitting
                                  ? "none"
                                  : "block",
                              }}
                              // ref={ref}
                              // display={
                              //   setDisabledAfterSuccessfullSubmitting
                              //     ? "none"
                              //     : "block"
                              // }
                            >
                              {isSubmitting ? "Submitting..." : "Submit   ttt"}{" "}
                            </button>
                          </Form>
                        );
                      }}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddEditSingleMeasurementOnOrderPage;
